/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router';
import _ from 'lodash';

import Districts from "../../models/districts.entity";
import UF from "../../models/uf.entity";
import ViacepAddress from "../../models/viacep-address.entity";
import {
  Error,
  ErrorRow,
  Form,
  FormRow,
  InputLabel,
  InputText,
  InputWrapper,
} from "../../Payment.styles";
import addressServices from "../../services/address.services";

import {
  Container,
  ModalForm,
  SubTitle,
  Title,
  BackBtn,
  SubmitBtn,
  ActionRow,
  FakeBg,
  Select,
  SelectState
} from "./TicketModal.styles";

import { SpinnerWhite } from '../../../../styles/Generic.styles';

import storageService from "../../../../services/storage.service";
import Inspection from "../../../../models/inspection.entity";
import PaymentBankSlip from "../../../../models/payment-back-slip.entity";
import Address from "../../models/address.entity";
import paymentService from "../../services/payment.service";
import PaymentSuccess from "../../../../models/payment-sucess.entity";
import inputMaskService from "../../../../services/input-mask.service";

const TicketModal = (props: any) => {
  const { price } = props;
  const history = useHistory();

  const [ufs, setUfs] = React.useState([]);
  const [districts, setDistricts] = React.useState<Districts[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [transaction, setTransaction] = React.useState(new Inspection());
  const [automaticAddress, setState] = React.useState(new ViacepAddress());
  const [errors, setErrors] = React.useState<string[]>([]);
  const paymentType = localStorage.getItem('payment-type');

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setState((prevState: any) => ({
      ...prevState,
      [name]: inputMaskService.getMaskedValue(name, value)
    }));
  };

  const onChangeZipCode = (e: any) => {
    const { value } = e.target;
    setState(new ViacepAddress());

    if (value.length === 8) {
      addressServices.getByZipCode(value)
        .then((result) => {
          const { data } = result;
          setState(new ViacepAddress(data));

          getDistrictsByUF(data.uf);
        });
    }
  }

  const getUfs = () => {
    /* istanbul ignore next */
    if (ufs.length > 0) {
      return;
    }

    addressServices.getUfs()
      .then((result) => {
        const { data } = result;
        /* istanbul ignore next */
        const ordained = _.orderBy(data, ['nome']) || [];
        let list: any = ordained.map((uf: UF) => new UF(uf));
        setUfs(list);
      })
      .catch(/* istanbul ignore next */ () => { });
  }

  const getDistrictsByUF = (uf: string) => {
    addressServices.getDistrictsByUF(uf)
      .then((result) => {
        const { data } = result;
        /* istanbul ignore next */
        const ordained = _.orderBy(data, ['nome']) || [];
        const list: Districts[] = ordained.map((districts: Districts) => new Districts(districts));

        const selectedDistrict = _
          .find(list, (district) => { return district.nome === automaticAddress.localidade });

        if (!selectedDistrict) {
          const district: Districts = new Districts();
          district.id = '123';
          district.nome = automaticAddress.localidade;

          list.push(district);
        }

        setDistricts(list);
      })
      .catch(/* istanbul ignore next */ () => { });
  }

  const handleValidation = () => {
    setErrors([]);
    let formIsValid = true;
    const formErrors: string[] = [];

    if (!automaticAddress.cep) {
      formIsValid = false;
      formErrors.push('O campo CEP é obrigatório');
    }

    if (!automaticAddress.logradouro) {
      formIsValid = false;
      formErrors.push('O campo Rua é obrigatório');
    }

    if (!automaticAddress.localidade) {
      formIsValid = false;
      formErrors.push('O campo Cidade é obrigatório');
    }

    if (!automaticAddress.numero) {
      formIsValid = false;
      formErrors.push('O campo Número até é obrigatório');
    }

    if (!automaticAddress.uf) {
      formIsValid = false;
      formErrors.push('O campo Estado até é obrigatório');
    }

    if (!automaticAddress.bairro) {
      formIsValid = false;
      formErrors.push('O campo Bairro até é obrigatório');
    }

    setErrors(formErrors);
    return formIsValid;
  };

  const generateBankSlip = () => {
    setLoading(true);

    if (!handleValidation()) {
      setLoading(false);
      return;
    }

    const payment = new PaymentBankSlip();

    const couponCode = localStorage.getItem('coupon');
    if (couponCode) {
      payment.couponCode = couponCode;
    }

    payment.userTransactionId = transaction.transactionId;
    payment.address = new Address(automaticAddress);
    payment.unitValue = price;

    paymentService.sendBankSlip(payment)
      .then((result) => {
        const { data } = result.data;
        const success = new PaymentSuccess(data);

        storageService.setObject('payment-sucess', success);
        history.push('success');
      })
      .catch((error) => {
        const requestErrors: string[] = [];

        const errorKeys = Object.keys(error);
        errorKeys.forEach((key) => {
          requestErrors.push(error[key][0]);
        });
        setErrors(requestErrors);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const goBack = () => {
    history.goBack();
  };

  useEffect(() => {
    getUfs();

    const inspection = storageService.getObject('inspection');
    setTransaction(inspection);
  }, []);

  useEffect(() => {
    if (!automaticAddress.uf) {
      return;
    }

    getDistrictsByUF(automaticAddress.uf);
  }, [automaticAddress.uf]);

  useEffect(() => {
    if (automaticAddress.cep.length === 8) {
      addressServices.getByZipCode(automaticAddress.cep)
        .then((result) => {
          const { data } = result;
          setState(new ViacepAddress(data));

          getDistrictsByUF(data.uf);
        });
    }
  }, [automaticAddress.cep]);

  const buttonText = paymentType === "pix" ? "Gerar Pix" : "Gerar Boleto";

  return (
    <>
      <Container>
        <Form>
          <FormRow>
            <InputWrapper>
              <InputLabel>CEP</InputLabel>
              <InputText
                type="text"
                placeholder="00000-000"
                maxLength="9"
                onChange={(e: any) => { onChangeZipCode(e); handleChange(e); }}
                onPaste={(e: any) => { onChangeZipCode(e); handleChange(e); }}
                value={automaticAddress.cep}
                name="cep"
                data-testid="input-ticket-zipcode"
              />
            </InputWrapper>
          </FormRow>
          <FormRow>
            <InputWrapper>
              <InputLabel>Rua</InputLabel>
              <InputText
                type="text"
                value={automaticAddress.logradouro}
                onChange={handleChange}
                name="logradouro"
                data-testid="input-ticket-address"
              />
            </InputWrapper>
          </FormRow>
          <FormRow>
            <InputWrapper>
              <InputLabel>Número</InputLabel>
              <InputText
                type="number"
                onChange={handleChange}
                value={automaticAddress.numero}
                name="numero"
                data-testid="input-ticket-number"
              />
            </InputWrapper>
            <InputWrapper>
              <InputLabel>Complemento</InputLabel>
              <InputText
                type="text"
                value={automaticAddress.complemento}
                onChange={handleChange}
                name="complemento"
                data-testid="input-ticket-complement"
              />
            </InputWrapper>
          </FormRow>
          <FormRow>
            <InputWrapper>
              <InputLabel>Bairro</InputLabel>
              <InputText
                type="text"
                value={automaticAddress.bairro}
                onChange={handleChange}
                name="bairro"
                data-testid="input-ticket-district"
              />
            </InputWrapper>
            <InputWrapper>
              <InputLabel>Selecione o estado</InputLabel>
              <SelectState
                value={automaticAddress.uf || ""}
                name="uf"
                onChange={handleChange}
                data-testid="input-ticket-state"
                styles="padding: 0px"
              >
                <option value="" disabled></option>
                {ufs && ufs.map((uf: UF) => (
                  <option
                    value={uf.sigla}
                    key={uf.sigla}
                    data-testid="option-ticket-state"
                  >{uf.nome}</option>
                ))}
              </SelectState>
            </InputWrapper>
          </FormRow>
          <FormRow>
            <InputWrapper>
              <InputLabel>Selecione a cidade</InputLabel>
              <Select
                value={automaticAddress.localidade}
                name="localidade"
                onChange={handleChange}
                data-testid="input-ticket-city"
              >
                {districts && districts.map((city: Districts) => (
                  <option
                    value={city.nome}
                    data-testid="option-ticket-city"
                  >{city.nome}</option>
                ))}
              </Select>
            </InputWrapper>
          </FormRow>
        </Form>
        {(errors.length > 0) && (
          <ErrorRow>
            {errors && errors.map((error: string, index) => (
              <Error key={index}>{error}</Error>
            ))}
          </ErrorRow>
        )}
        <ActionRow>
          <SubmitBtn
            disabled={loading}
            onClick={() => { generateBankSlip() }}
            data-testid="generate-ticket-btn"
          >
            {loading && (
              <SpinnerWhite />
            )}
            {!loading && (
              <>{buttonText}</>
            )}
          </SubmitBtn>
          <BackBtn
            disabled={loading}
            data-testid="cancel-btn"
            onClick={() => { goBack() }}
          >
            Voltar
          </BackBtn>
        </ActionRow>
      </Container>
    </>
  );
};

export default TicketModal;
